/**
 * @public
 */
export enum ConversationStateTypes {
  dpSpeaking = 'dpSpeaking',
  userSpeaking = 'userSpeaking',
  dpProcessing = 'dpProcessing',
  idle = 'idle',
}
